import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@soluto-private/mx-asurion-ui-react';

import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';

import { SectionContainer, SectionTitle } from '../components';

const TEXT = TranslationEntries.Repairs.Cart.Disclaimer;

export const NeedToRescheduleSection: FC = () => {
  const { t } = useTranslation();

  return (
    <SectionContainer skeletonHeight="75px">
      <SectionTitle>{t(TEXT.Title)}</SectionTitle>
      <Text>{t(TEXT.PrimaryText)}</Text>
    </SectionContainer>
  );
};
